<template>
  <div class="py-10">
    <v-layout
      align-center
      justify-center
    >
      <v-alert
        :value="alert_error"
        type="error"
        transition="scale-transition"
      >{{errorMessage}}</v-alert>
      <v-alert
        :value="alert_ok"
        type="success"
        transition="scale-transition"
      >{{okMessage}}</v-alert>
      <v-card
        elevation="2"
        class="mx-auto"
      >
        <v-card-title>Reporte de Tickets</v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <v-form v-model="valid">
            <v-container>
              <v-row>

                <v-col
                  cols="12"
                  md="4"
                >
                  <v-menu
                    v-model="menuDI"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        v-model="dateInit"
                        label="Fecha Inicial"
                        prepend-icon="mdi-calendar"
                        readonly
                        v-bind="attrs"
                        v-on="on"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="dateInit"
                      @input="menuDI = false"
                    ></v-date-picker>
                  </v-menu>
                </v-col>

                <v-col
                  cols="12"
                  md="4"
                >
                  <v-menu
                    v-model="menuDE"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        v-model="dateEnd"
                        label="Fecha Final"
                        prepend-icon="mdi-calendar"
                        readonly
                        v-bind="attrs"
                        v-on="on"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="dateEnd"
                      @input="menuDE = false"
                    ></v-date-picker>
                  </v-menu>
                </v-col>
                <v-col
                  cols="12"
                  md="4"
                >
                  <v-select
                    v-model="estado"
                    :items="['Todos','Facturados','No Facturados']"
                    label="Estado del Ticket"
                  ></v-select>
                </v-col>
                <v-col
                  cols="12"
                  md="8"
                >

                </v-col>
                <v-col
                  cols="12"
                  md="4"
                >
                  <v-btn
                    @click="ticketSearch"
                    color="primary"
                    :disabled="!showBtn"
                  >Descargar</v-btn>
                </v-col>
              </v-row>
            </v-container>
          </v-form>
        </v-card-text>
      </v-card>
    </v-layout>
  </div>
</template>

<script>
import { executeAction } from "../scripts/baseService.js";
import helpers from "../scripts/helpers.js";
export default {
  name: "Reporte",
  components: {},
  data() {
    return {
      dateInit: null,
      dateEnd: null,
      menuDI: false,
      menuDE: false,
      estado: "Todos",
      alert_error: false,
      errorMessage: "",
      okMessage: "",
      alert_ok: false,
    };
  },
  methods: {
    async ticketSearch() {
      let status = "";
      switch (this.estado) {
        case "Todos":
          status = "";
          break;
        case "Facturados":
          status = "1";
          break;
        case "No Facturados":
          status = "0";
          break;

        default:
          status = "";
          break;
      }
      let jsonData = {
        date_init: this.dateInit,
        date_end: this.dateEnd,
        status: status,
        token: this.$store.state.token,
      };
      await executeAction("POST", "Ticket/Search", jsonData, false).then(
        (response) => {
          this.$store.commit("setOverlay", false);
          if (!response.result) {
            this.alert_error = true;
            this.errorMessage = response.errorMessage;
            setTimeout(() => {
              this.alert_error = false;
              this.errorMessage = "";
            }, 5000);
          } else {
            helpers.ToCSV(
              response.payload,
              "Reporte_Tickets_" + helpers.dateNow().toString() + ".csv"
            );
          }
        }
      );
    },
  },
  computed: {
    showBtn() {
      return this.dateInit && this.dateEnd && this.estado;
    },
  },
  mounted() {},
  created() {
    this.$store.commit("setIssue", false);
  },
};
</script>

<style>
</style>
